"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.text = exports.roundToInterval = exports.line = exports.coverageCodeForPercent = void 0;
var _utils = require("../../../utils");
const roundToInterval = (value, int) => Math.floor((value + int / 2) / int) * int;
exports.roundToInterval = roundToInterval;
const coverageCodeForPercent = percent => {
  if (!(0, _utils.isset)(percent)) {
    return null;
  }
  if (percent === 100) {
    return 8;
  }
  if (percent > 80) {
    return 7;
  }
  if (percent > 60) {
    return 6;
  }
  if (percent > 50) {
    return 5;
  }
  if (percent > 40) {
    return 4;
  }
  if (percent > 30) {
    return 3;
  }
  if (percent > 20) {
    return 2;
  }
  if (percent > 10) {
    return 1;
  }
  return 0;
};
exports.coverageCodeForPercent = coverageCodeForPercent;
const text = (value, x, y, opts) => {
  opts = (0, _utils.extend)({
    anchor: 'end',
    size: '1.5px',
    font: null,
    fill: 'black',
    stroke: 0.5,
    link: null
  }, opts);
  const style = {
    'font-size': opts.size
  };
  if (opts.font) {
    style['font-family'] = opts.font;
  }
  const styleStr = `${Object.keys(style).map(prop => `${prop}: ${style[prop]}`).join('; ')};`;
  if (opts.link) {
    return `
			<text x="${x}" y="${y}" text-anchor="${opts.anchor}" style="${styleStr}" stroke="white" stroke-width="${opts.stroke}">${value}</text>
			<a href="https://www.aviationweather.gov/metar/symbol" target="_blank">
				<text x="${x}" y="${y}" text-anchor="${opts.anchor}" style="${styleStr} text-decoration: underline; cursor: pointer;" fill="${opts.fill}">${value}</text>
			</a>
		`;
  }
  return `
		<text x="${x}" y="${y}" text-anchor="${opts.anchor}" style="${styleStr}" stroke="white" stroke-width="${opts.stroke}">${value}</text>
		<text x="${x}" y="${y}" text-anchor="${opts.anchor}" style="${styleStr}" fill="${opts.fill}">${value}</text>
	`;
};
exports.text = text;
const line = (x1, y1, x2, y2) => `
	<line x1="${x1}" y1="${y1}" x2="${x2}" y2="${y2}" stroke="white" stroke-width=".5"></line>
	<line x1="${x1}" y1="${y1}" x2="${x2}" y2="${y2}" stroke="black" stroke-width=".2"></line>
`;
exports.line = line;